import { render } from "./EvaluacionDocentePage.vue?vue&type=template&id=128a5226"
import script from "./EvaluacionDocentePage.vue?vue&type=script&lang=js"
export * from "./EvaluacionDocentePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__